// extracted by mini-css-extract-plugin
export default {"root":"HaurakiLogo_root__trCBF","mark":"HaurakiLogo_mark__B7C6K","wordmark":"HaurakiLogo_wordmark__ww34R"};